/** @internal */
export const mediaElementSourceNodes = new WeakMap<HTMLAudioElement, MediaElementAudioSourceNode>();
